// src/config/brandTheme.js
// Applique la charte ARTICHAUT (polices + variables) quand le build est ARTICHAUT.
// Les styles sont dans src/styles/brand-theme.css. Sans effet sur le build ARTKIV.
import { BRAND_LOGO_VARIANT } from "./brand";

const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Bodoni+Moda:opsz,wght@6..96,400;6..96,500;6..96,600&family=Manrope:wght@300;400;500;600;700&display=swap";

export function applyBrandTheme() {
  if (BRAND_LOGO_VARIANT !== "artichaut" || typeof document === "undefined") return;
  document.documentElement.setAttribute("data-brand", "artichaut");
  if (!document.querySelector("link[data-brand-fonts]")) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = FONTS_HREF;
    link.setAttribute("data-brand-fonts", "");
    document.head.appendChild(link);
  }
}
